//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      showTrajectoryVal: false,
      // showTrajectory: false, // 是否显示轨迹
      hasShowTrajectoryBtn: true, // 是否有显示轨迹按钮
      checkedItem: { id: 11111 }, // 选中的筛选项
    };
  },
  props: {
    // 顶部信息配置项
    mapTopInfoOptions: {
      type: Object,
      default: function () {
        return {
          hasAll: false,
          isFilter: false,
          data: [],
          hasData: true,
        };
      },
    },
  },
  computed: {
    ...mapState("map", {
      showTrajectory: (state) => state.showTrajectory,
    }),
  },
  watch: {
    showTrajectory(n) {
      // this.$bus.$emit("showTrajectory", n);
      this.changeShowTrajectory(n);
      this.showTrajectoryVal = n;
    },
    "checkedItem.id": {
      handler: function (n) {
        if (this.mapTopInfoOptions.hasData) {
          if (n == 11111) {
            this.hasShowTrajectoryBtn = false;
          } else {
            if (this.mapTopInfoOptions.hasShowTrajectoryBtn) {
              this.hasShowTrajectoryBtn = true;
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions("map", ["changeShowTrajectory"]),
    /**
     * @descripttion: 筛选地图
     * @Author: juanjuanhui
     * @Date: 2021-12-10 11:32:05
     * @param {*} item
     */
    handleFilterMap(item) {
      this.checkedItem = item;
      this.$bus.$emit("filterMap", item);
    },
  },
};
